export type HomeSectionKey = "hero" | "promo" | "products" | string;

export type HomeSection = {
  HomeSectionId: string;
  SectionKey: HomeSectionKey;
  AdminTitle: string;
  Eyebrow: string | null;
  Title: string;
  Subtitle: string | null;
  Description: string | null;
  BadgeText: string | null;
  ImageUrl: string | null;
  MobileImageUrl: string | null;
  ImageAlt: string | null;
  PrimaryButtonLabel: string | null;
  PrimaryButtonUrl: string | null;
  SecondaryButtonLabel: string | null;
  SecondaryButtonUrl: string | null;
  NoteText: string | null;
  Tags: string[];
  IsActive: boolean;
  SortOrder: number;
  CreatedAt?: string | null;
  UpdatedAt?: string | null;
};

function normalizeSection(item: Record<string, unknown>): HomeSection {
  return {
    HomeSectionId: String(item.HomeSectionId || ""),
    SectionKey: String(item.SectionKey || ""),
    AdminTitle: String(item.AdminTitle || ""),
    Eyebrow: item.Eyebrow ? String(item.Eyebrow) : null,
    Title: String(item.Title || ""),
    Subtitle: item.Subtitle ? String(item.Subtitle) : null,
    Description: item.Description ? String(item.Description) : null,
    BadgeText: item.BadgeText ? String(item.BadgeText) : null,
    ImageUrl: item.ImageUrl ? String(item.ImageUrl) : null,
    MobileImageUrl: item.MobileImageUrl ? String(item.MobileImageUrl) : null,
    ImageAlt: item.ImageAlt ? String(item.ImageAlt) : null,
    PrimaryButtonLabel: item.PrimaryButtonLabel ? String(item.PrimaryButtonLabel) : null,
    PrimaryButtonUrl: item.PrimaryButtonUrl ? String(item.PrimaryButtonUrl) : null,
    SecondaryButtonLabel: item.SecondaryButtonLabel ? String(item.SecondaryButtonLabel) : null,
    SecondaryButtonUrl: item.SecondaryButtonUrl ? String(item.SecondaryButtonUrl) : null,
    NoteText: item.NoteText ? String(item.NoteText) : null,
    Tags: Array.isArray(item.Tags) ? item.Tags.map((tag) => String(tag)).filter(Boolean) : [],
    IsActive: item.IsActive !== false,
    SortOrder: Number(item.SortOrder || 100),
    CreatedAt: item.CreatedAt ? String(item.CreatedAt) : null,
    UpdatedAt: item.UpdatedAt ? String(item.UpdatedAt) : null,
  };
}

export async function fetchPublicHomeSections() {
  const response = await fetch("/api/home-sections", { headers: { Accept: "application/json" } });
  if (!response.ok) {
    throw new Error("首頁區塊讀取失敗");
  }
  const data = (await response.json()) as { Items?: Record<string, unknown>[] };
  return (data.Items || []).map(normalizeSection);
}

export function sectionByKey(items: HomeSection[], key: HomeSectionKey) {
  return items.find((item) => item.SectionKey === key) || null;
}
